import React from 'react';
import { Check } from 'lucide-react';
import { AnimatedSection } from './ui/AnimatedSection';
export function PricingOptions() {
  return <AnimatedSection id="pricing" className="pt-10 pb-20" data-id="element-192">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-193">
        <h2 className="text-2xl sm:text-3xl md:text-5xl font-heading font-bold text-center mb-12 sm:mb-16 leading-tight" data-id="element-194">
          ELEGÍ TU MEGA PACK
        </h2>

        <div className="grid md:grid-cols-2 gap-10 md:gap-8 items-stretch" data-id="element-195">
          {/* Option 1 */}
          <div className="bg-dark-card border border-dark-border rounded-2xl p-6 sm:p-8 flex flex-col relative" data-id="element-196">
            <div className="mb-6" data-id="element-197">
              <h3 className="text-xl sm:text-2xl font-heading font-bold text-white mb-2 flex items-center gap-2 leading-tight" data-id="element-198">
                <span className="text-2xl" data-id="element-199">📘</span> MEGA PACK KINESIOLOGÍA
              </h3>
              <p className="text-gold font-semibold text-sm sm:text-base" data-id="element-200">
                6 Tomos + 6 Bonos
              </p>
            </div>

            <div className="bg-navy-900/50 rounded-lg p-3 sm:p-4 mb-6 text-xs sm:text-sm text-gray-300 border border-dark-border/50" data-id="element-201">
              <span className="font-bold text-white" data-id="element-202">Ideal para:</span>{' '}
              Estudiantes avanzados y kinesiólogos junior
            </div>

            <div className="mb-6 sm:mb-8" data-id="element-203">
              <span className="text-gray-500 line-through text-lg sm:text-xl block mb-1" data-id="element-204">
                $51.000
              </span>
              <div className="flex items-baseline gap-2" data-id="element-205">
                <span className="text-4xl sm:text-5xl font-heading font-bold text-white" data-id="element-206">
                  $19.990
                </span>
                <span className="text-lg sm:text-xl text-gray-400" data-id="element-207">ARS</span>
              </div>
            </div>

            <div className="mt-auto" data-id="element-208">
              <a href="#" className="block w-full text-center bg-navy-800 hover:bg-navy-700 text-white border border-dark-border font-bold text-base sm:text-lg px-6 py-4 rounded-full transition-colors" data-id="element-209">
                → QUIERO EL MEGA PACK
              </a>
            </div>
          </div>

          {/* Option 2 (Featured) */}
          <div className="bg-navy-900 border-2 border-gold rounded-2xl p-6 sm:p-8 flex flex-col relative transform md:-translate-y-4 shadow-[0_0_40px_rgba(201,168,76,0.15)]" data-id="element-210">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-gold text-navy-950 font-bold px-4 py-1 rounded-full text-xs sm:text-sm tracking-widest uppercase shadow-lg" data-id="element-211">
              Recomendado
            </div>

            <div className="mb-6" data-id="element-212">
              <h3 className="text-xl sm:text-2xl font-heading font-bold text-white mb-2 flex items-center gap-2 leading-tight" data-id="element-213">
                <span className="text-2xl" data-id="element-214">🏆</span> MEGA PACK + RAZONAMIENTO
                AVANZADO ⭐
              </h3>
              <p className="text-gold font-semibold text-sm sm:text-base" data-id="element-215">
                6 Tomos + 6 Bonos + 30 casos clínicos adicionales resueltos
              </p>
            </div>

            <div className="bg-navy-950/50 rounded-lg p-3 sm:p-4 mb-6 text-xs sm:text-sm text-gray-300 border border-gold/20" data-id="element-216">
              <span className="font-bold text-white" data-id="element-217">Ideal para:</span>{' '}
              Internado, primeros años de ejercicio profesional, preparación de
              exámenes finales
            </div>

            <div className="mb-6 sm:mb-8" data-id="element-218">
              <span className="text-gray-500 line-through text-lg sm:text-xl block mb-1" data-id="element-219">
                $69.000
              </span>
              <div className="flex items-baseline gap-2" data-id="element-220">
                <span className="text-4xl sm:text-5xl font-heading font-bold text-gold" data-id="element-221">
                  $27.990
                </span>
                <span className="text-lg sm:text-xl text-gray-400" data-id="element-222">ARS</span>
              </div>
            </div>

            <div className="mt-auto" data-id="element-223">
              <a href="#" className="block w-full text-center bg-gold hover:bg-gold-hover text-navy-950 font-bold text-base sm:text-lg px-6 py-4 rounded-full transition-all transform hover:scale-105 shadow-[0_0_20px_rgba(201,168,76,0.4)]" data-id="element-224">
                → QUIERO EL PACK + AVANZADO
              </a>
            </div>
          </div>
        </div>
      </div>
    </AnimatedSection>;
}